/* eslint-disable jsx-a11y/alt-text */
import React, { useState } from "react";
import {
    Container,
    Box,
    Paper,
    Grid,
    Typography,
    Button,
    Card,
    CardContent,
    Chip,
    Divider,
    IconButton
} from '@mui/material';
import PodcastsIcon from '@mui/icons-material/Podcasts';
import PlayCircleIcon from '@mui/icons-material/PlayCircle';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import Footer from '../core/Footer';

const Podcast = () => {
    const episodes = [
        {   number: 30,
            title: "Melissa Wastel from Ulteig",
            description: "Melissa joins us to talk Innovation",
            year: "2026",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E06-Shrirang.mp3"
        },
        {   number: 29,
            title: "Shrirang Abhyankar shares some of his amazing research and project work",
            description: "Shrirang 'Shri' Abhyankar—formerly at Pacific Northwest National Laboratory and Argonne National Laboratory—now serves as Grid Transformation Principal at ERCOT. In this episode, Shri explains how grid modeling, simulation, applied mathematics, and AI converge in real operations. We also explore the open-source tools his work helped shape, including Exascale Grid Optimization (ExaGO), ChatGrid, and Grid coPilot, and what these innovations mean for the future of grid planning and control. Shrirang Abhyankar Principal - AI & Optimization | IEEE senior member https://www.linkedin.com/in/shrirang-abhyankar-59018144/ some project links https://www.pnnl.gov/publications/grid-modeling-tool-successfully-launches-worlds-fastest-supercomputer https://www.pnnl.gov/news-media/chatgridtm-new-generative-ai-tool-power-grid-visualization https://www.preprints.org/manuscript/202504.1464",
            year: "2026",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E06-Shrirang.mp3"
        },
        {
            number: 28,
            title: "Nelson Antunes from Eversource - Revit, Standards and Design Automation",
            description: "Nelson is the Supervisor of Substation Design and Drafting at Eversource Energy. He joins Cory and I on this episode to talk about his experience with Revit, the Eversource team, attending the SDSIC and much much more. https://www.linkedin.com/in/nelson-antunes-64a46374/",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E04-NelsonAnrtunes.mp3"
        },
        {
            number: 27,
            title: "Shabnam Pazooki from WSP - Pushing the Envelope with Revit",
            description: "Shabnam has been pushing the envelope of Revit at Power Engineers (now WSP) and sharing that knowledge with the SDSIC members for the past three conferences. We are privileged to have her join our podcast and share her knowledge, experience, and just the pure joy of her personality! Join us and listen in to some of her great advice. Shabnam Pazooki, Senior Technical Manager at WSP https://www.linkedin.com/in/shabnampazooki/",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E03-Shabnam.mp3"
        },
        {
            number: 26,
            title: "Meet the Duke Energy Team - Live from Chattanooga",
            description: "Trevor and Cory sit down for a conversation with the Duke Energy team live from our SDSIC conference in Chattanooga, Tennessee. Joining us from Duke are Crystal Myers P.E., Manager of PGO Grid Ops Perf & Tech and Design Automation Tools & Support (DATS), Peter Coffey, Director of Operational Performance & Technology, Mark Thomas, Design Automation Tool Support Specialist, and Justin Martin, ACADE SME in the DATS group. Duke Energy has been with the SDSIC since day one and have helped shape the consortium and various products over the years.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E02-DukeTeam.mp3"
        },
        {
            number: 25,
            title: "A Talk with ePlan - Live from Chattanooga",
            description: "Trevor and Cory sit down for a conversation with the ePlan team live from our SDSIC conference in Chattanooga, Tennessee. Joining us from ePlan are Adrian Melendez, Energy Enthusiast and Business Development Professional, and Jan Oliver Kammesheidt, Global Vertical Market Manager Energy. Adrian and Jan 'Ollie' Oliver are big supporters of the SDSIC, sponsoring our live annual events and presenting great content to keep our members up to date on the latest technology.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S25-E01_Eplan.mp3"
        },
        {
            number: 24,
            title: "Jeff Danley and Michael Bussinger from Burns & McDonnell - Innovation",
            description: "Jeff and Michael join me to talk about Innovation at Burns & McDonnell including; Establishing a structured innovation program focused on Objectives and Key Results (OKRs). Importance of aligning innovation efforts with corporate goals. The role of AI in transforming multiple business functions, including construction, finance, and software development.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E24-JeffDanley.mp3"
        },
        {
            number: 23,
            title: "Bonus Episode - AI in the Electric Utility Space",
            description: "We needed one more! This is a bonus episode from our series on Artificial intelligence in the Electric Utility industry and special SDSIC members Michael Bussinger, Cory Byrnes, Anthony Contino, Ben Ferneau, Josue Sanchez, and Shawn Weekly joins us for some incredible conversations around AI.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E23-AI_podcast_Episode_bonus.mp3"
        },
        {
            number: 22,
            title: "AI Series - Part 3 of 3",
            description: "This is the third episode of our three part series on Artificial intelligence in the Electric Utility industry and special SDSIC members Michael Bussinger, Cory Byrnes, Anthony Contino, Ben Ferneau, Josue Sanchez, and Shawn Weekly joins us for some incredible conversations around AI.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E22-AI_podcast_Episode3.mp3"
        },
        {
            number: 21,
            title: "AI Series - Part 2 of 3",
            description: "This is the second episode of our three part series on Artificial intelligence in the Electric Utility industry and special SDSIC members Michael Bussinger, Cory Byrnes, Anthony Contino, Ben Ferneau, Josue Sanchez, and Shawn Weekly joins us for some incredible conversations around AI.",
            year: "2025",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E21-AI_podcast_Episode2.mp3"
        },
        {
            number: 20,
            title: "AI Series - Part 1 of 3",
            description: "This is the first episode of our three episode series on Artificial intelligence in the Electric Utility industry and special SDSIC members Michael Bussinger, Cory Byrnes, Anthony Contino, Ben Ferneau, Josue Sanchez, and Shawn Weekly joins us for some incredible conversations around AI.",
            year: "2024",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E20-AI_podcast_Episode1.mp3"
        },
        {
            number: 19,
            title: "Katie Muer from Black & Veatch and Scott Dimpfl",
            description: "Katie Muer from Black and Veatch joins Scott Dimpfl, our SDSIC Vice Chair and myself so we can chat about this year's amazing SDSIC live conference in Kansas City that Black & Veatch hosted! We talk about what it takes to host an event, Katie offers some advice and Scott runs the Q&A! Listen in!",
            year: "2024",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E19-KatieMuer-BlackAndVeatch.mp3"
        },
        {
            number: 18,
            title: "Cory Byrnes from Beta Engineering",
            description: "Cory Byrnes from Beta Engineering joins me and we chat about his Civil and Structural engineering work at BETA, his newly minted membership in the SDSIC, advice for other SDSIC newbies, why your should get involved, and of course ... we talk technology and AI.",
            year: "2024",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S24-E18-CoryByrnes.mp3"
        },
        {
            number: 17,
            title: "2023: The Year in Review",
            description: "In this episode we close out 2023 by pulling some tidbits of advice on the SDSIC from each conversation through the 2023 year.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E17-EndOfYear23.mp3"
        },
        {
            number: 16,
            title: "Scott Dimpfl from AEP",
            description: "Scott Dimpfl is Director of Transmission Line Engineering at AEP and our current Chair for the Technology committee. With over 20 years of experience, Scott has some in depth knowledge to share and we explore some of what he's championing at AEP these days.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E16-ScottDimpfl.mp3"
        },
        {
            number: 15,
            title: "Jack Hopson from Autodesk",
            description: "Jack Hopson is a Technical Solutions Executive for the Utilities Industries at Autodesk and has been with our SDSIC community for many years now. He has an interesting perspective on our industry having worked at Ameren and for several technology firms over the years both implementing and delivering solutions.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E15-JackHopson.mp3"
        },
        {
            number: 14,
            title: "Michael Goins from POWER Engineers",
            description: "Michael Goins is a Senior Project Engineer at POWER Engineers today and 10 years ago this year, he was the very first SDSIC chair elected. His early work with the SDSIC was instrumental in setting things up to drive the success we have today.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E14-MichaelGoins.mp3"
        },
        {
            number: 13,
            title: "Michael Bussinger from Burns & McDonnell",
            description: "Michael joined me to talk about his work as our SDSIC co-Chair for the Civil Structural committee. We also talked about the work he does at Burns & McDonnell and, as an Adjunct Instructor at Metropolitan Community College-Maple Woods where we discover that Michael has a true passion for teaching others. Have a listen!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E13-MichaelBussinger.mp3"
        },
        {
            number: 12,
            title: "Dennis Beck co-founder and CEO from SBS",
            description: "Dennis is the co-founder and CEO of SBS, the tech company behind the AUD and SDS product suites used by so many members of the SDSIC. Dennis chats with me about his company, the team and all the software products. We even step into some conversation about future tech and some excellent advice for SDSIC Members.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E12-DennisBeck.mp3"
        },
        {
            number: 11,
            title: "Michael Bruce co-founder of 3D Transition Services",
            description: "Michael joined me to chat about the SDSIC, 3D technology new and old, different ways in which designers can embrace 3D technology and where he sees the industry headed! Have a listen!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E11-MichaelBruce.mp3"
        },
        {
            number: 10,
            title: "Duane Guidry from POWER Engineers",
            description: "Duane is the Technology Partner Director at POWER Engineers and has been around the SDSIC since the concept was first discussed. He has helped us plan and grow since then and continues that same support today. He joins me and we talk about his interesting history in this industry and lots of SDSIC talk. Enjoy!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E10-DuaneGuidry.mp3"
        },
        {
            number: 9,
            title: "Mark Nelson from Idaho Power",
            description: "Mark is our current SDSIC 2023 co-chair and has been a long standing member having run the technology committee as chair and co-chair over the years. We had a great talk about our consortium, technology, advice on how to run committees and even some great advice for new members joining us for the first time. Have a listen!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E09-MarkNelson.mp3"
        },
        {
            number: 8,
            title: "Shawn Weekly from POWER Engineers",
            description: "Shawn is a Digital Transformation Architect at POWER Engineers and one of the earliest members of the SDSIC having been the technology chair and now the co-chair of the New Innovative Solutions committee. We chat about his background with the SDSIC, technology, and the power industry as a whole!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E08-ShawnWeekly.mp3"
        },
        {
            number: 7,
            title: "Josh Clark from PPL Electric Utilities",
            description: "Josh is the current Chair of the SDSIC Physical Committee and a Design Drafter at PPL Electric Utilities. He has been running the committee for over two terms now and he joins me to chat about how he got started in design, his career path, CAD technology past, present and future, and he offers up some great advice for members new to the consortium.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E07-JoshClark.mp3"
        },
        {
            number: 6,
            title: "Jeremy Morton from POWER Engineers",
            description: "Jeremy is one of the original founders of the SDSIC and has held more seats than any other member having started the Physical committee, held the SDSC Chair for a few years and now as the co-chair of the Business Strategy committee. On this episode, we talk about his history, technology and how he sees things progressing in the future. Have a listen!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E06-Jeremy Morton.mp3"
        },
        {
            number: 5,
            title: "Ernie Barton from Southern Company",
            description: "Ernie has started up a brand new group for the SDSIC, the Innovative Solutions Committee. His current role as the Information Delivery Tools supervisor in the Business Process and Innovations Groups and his experience make him the perfect choice to head up this new group. Listen in and learn more!",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E05 - Ernie Barton.mp3"
        },
        {
            number: 4,
            title: "Justin Martin from Duke Energy",
            description: "Justin is the current Chair of the SDSIC Electrical Committee and a Senior Engineering Technologist / ACADE SME at Duke Energy. He joins us to chat about how he got started in design, his career path and he offers up some great advice for members new to the consortium and even for those new to design.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E04-JustinMartin.mp3"
        },
        {
            number: 3,
            title: "Bill Gordon From Southern Company",
            description: "Bill is a founding member of the SDSIC even coining the tagline \"Design. Integrate. Automate.\" for us early on. He has led the Electrical committee in the past and now heads up the Business Strategy Committee. We chat about his career, goals for his committee and he provides some valuable advice for new members.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E03-BillGordon.mp3"
        },
        {
            number: 2,
            title: "Audrey Marich from PPL Electric Utility",
            description: "Audrey Marich is currently, and has been the SDSIC Chair for the past three years. She has grown our membership to 1,700 members and guided us through the pandemic via virtual conferences and zoom meetings. Join us as we discuss the SDSIC charter changes, what's in store for the 10th anniversary and tips for new members just getting involved.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E02-AudreyMarich.mp3"
        },
        {
            number: 1,
            title: "Jeff Spence from Ampirical",
            description: "We kick off our podcast with long time member, Jeff Spence, VP of Strategic Innovations at Ampirical Solutions. He joins us to talk about 10 years of the SDSIC, tips on getting started with intelligent design, how to get the most our of your SDSIC peers and we even touch on cyber security.",
            year: "2023",
            audioUrl: "https://sdsic-podcast.s3.us-east-1.amazonaws.com/S01-E01-JeffSpence.mp3"
        }
    ];

    const [selectedEpisode, setSelectedEpisode] = useState(episodes[0]);

    return (
        <>
            {/* Hero Section */}
            <Box sx={{ backgroundColor: '#003E7E', color: 'white', py: 6, mb: 4 }}>
                <Container maxWidth="lg">
                    <Grid container spacing={4} alignItems="center">
                        <Grid item xs={12} md={6}>
                            <a href="https://powerup-podcast.com" target="_blank" rel="noopener noreferrer">
                                <Box
                                    component="img"
                                    src="/images/PowerUpLogo2025.png"
                                    sx={{
                                        width: '100%',
                                        maxWidth: 400,
                                        height: 'auto',
                                        transition: 'transform 0.3s ease',
                                        '&:hover': {
                                            transform: 'scale(1.05)'
                                        }
                                    }}
                                />
                            </a>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                <PodcastsIcon sx={{ fontSize: 48 }} />
                                <Typography variant="h3" component="h1" sx={{ fontWeight: 700 }}>
                                    the PowerUp podcast
                                </Typography>
                            </Box>
                            <Typography variant="h6" sx={{ mb: 2, lineHeight: 1.6, opacity: 0.95 }}>
                                Honest conversations about the future of energy, AI, and engineering — hosted by industry veterans <strong>Trevor Scullion</strong> & <strong>Cory Byrnes</strong>.
                            </Typography>
                            <Typography variant="body1" sx={{ lineHeight: 1.7, opacity: 0.9 }}>
                                We believe that every engineer, designer, and utility professional deserves clear, hype‑free insights into how technology is reshaping the grid. The podcast cuts through buzzwords, spotlighting the real‑world wins and lessons learned so you can build a safer, smarter, more resilient energy future.
                            </Typography>
                        </Grid>
                    </Grid>
                </Container>
            </Box>

            <Container maxWidth="lg" sx={{ mb: 6 }}>

                <Divider sx={{ my: 5 }} />

                {/* SDSIC Series Episodes */}
                <Typography variant="h4" sx={{ fontWeight: 600, color: '#003E7E', mb: 4 }}>
                    Our SDSIC Series
                </Typography>

                <Grid container spacing={3}>
                    {/* Episode List */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" sx={{ fontWeight: 600, color: '#003E7E', mb: 2 }}>
                            Episodes
                        </Typography>
                        <Box sx={{ maxHeight: '800px', overflowY: 'auto', pr: 1 }}>
                            {episodes.map((episode) => (
                                <Card
                                    key={episode.number}
                                    onClick={() => setSelectedEpisode(episode)}
                                    elevation={selectedEpisode.number === episode.number ? 4 : 1}
                                    sx={{
                                        mb: 2,
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease',
                                        backgroundColor: selectedEpisode.number === episode.number ? '#003E7E' : 'white',
                                        color: selectedEpisode.number === episode.number ? 'white' : 'inherit',
                                        '&:hover': {
                                            transform: 'translateX(8px)',
                                            boxShadow: '0 4px 12px rgba(0, 62, 126, 0.2)',
                                        }
                                    }}
                                >
                                    <CardContent sx={{ p: 2 }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <Chip
                                                label={`EP ${episode.number}`}
                                                size="small"
                                                sx={{
                                                    backgroundColor: selectedEpisode.number === episode.number ? '#FF6600' : '#003E7E',
                                                    color: 'white',
                                                    fontWeight: 700
                                                }}
                                            />
                                            <Chip
                                                label={episode.year}
                                                size="small"
                                                sx={{
                                                    backgroundColor: selectedEpisode.number === episode.number ? 'rgba(255, 255, 255, 0.2)' : 'rgba(0, 62, 126, 0.1)',
                                                    color: selectedEpisode.number === episode.number ? 'white' : '#003E7E',
                                                    fontWeight: 600
                                                }}
                                            />
                                        </Box>
                                        <Typography variant="body2" sx={{ fontWeight: 600, lineHeight: 1.4 }}>
                                            {episode.title}
                                        </Typography>
                                    </CardContent>
                                </Card>
                            ))}
                        </Box>
                    </Grid>

                    {/* Episode Player */}
                    <Grid item xs={12} md={8}>
                        <Paper
                            elevation={4}
                            sx={{
                                p: 4,
                                borderRadius: 3,
                                border: '2px solid #003E7E'
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                <PlayCircleIcon sx={{ fontSize: 40, color: '#FF6600' }} />
                                <Box>
                                    <Typography variant="h5" sx={{ fontWeight: 600, color: '#003E7E' }}>
                                        Episode {selectedEpisode.number}
                                    </Typography>
                                    <Typography variant="h6" sx={{ color: '#666' }}>
                                        {selectedEpisode.title}
                                    </Typography>
                                </Box>
                            </Box>

                            <Chip
                                label={selectedEpisode.year}
                                sx={{
                                    backgroundColor: '#003E7E',
                                    color: 'white',
                                    fontWeight: 600,
                                    mb: 2
                                }}
                            />

                            <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.8 }}>
                                {selectedEpisode.description}
                            </Typography>

                            <Paper
                                elevation={2}
                                sx={{
                                    borderRadius: 2,
                                    overflow: 'hidden',
                                    border: '2px solid #FF6600'
                                }}
                            >
                                <iframe
                                    src={selectedEpisode.audioUrl}
                                    style={{ width: "100%", height: "180px", border: "none" }}
                                    title="PowerUp: Conversations with SDSIC Members"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                    allowFullScreen
                                />
                            </Paper>
                        </Paper>
                    </Grid>
                </Grid>
            </Container>

            <Footer />
        </>
    );
};

export default Podcast;
